import React from "react";
import { Link } from "react-router-dom";
import { ASSETS } from "../config/assets";

const PHASES = [
  {
    title: "Get started on the platform",
    steps: [
      "Register with company details and verify OTP.",
      "Sign in and open Projects.",
      "Create a project (channel) that will hold your WhatsApp Business Account.",
    ],
  },
  {
    title: "Connect WhatsApp with Embedded Signup",
    steps: [
      "Click Connect WhatsApp and choose the project to link.",
      "Launch Meta Embedded Signup (Facebook popup).",
      "Authenticate with Facebook or Meta Business credentials.",
      "Select or create a Meta Business Portfolio.",
      "Select an existing WhatsApp Business Account (WABA) or create a new one.",
      "Add or choose a business phone number and set the display name.",
      "Verify the number (SMS or voice) and accept Cloud API / WhatsApp terms.",
      "Grant the app whatsapp_business_management and whatsapp_business_messaging.",
    ],
  },
  {
    title: "Platform completes onboarding (server-side)",
    steps: [
      "The browser sends the code and asset IDs to the platform — the code is never exchanged in the browser.",
      "The server exchanges the code for a Business Integration System User (BISU) token using the app secret.",
      "The platform stores WABA ID and phone number ID on the project.",
      "The app is subscribed to the customer WABA so webhooks are delivered.",
      "The phone number is registered with Cloud API (PIN) so it can send and receive.",
    ],
  },
  {
    title: "Configure the WhatsApp channel",
    steps: [
      "Update WhatsApp Business Profile (about, address, website, vertical).",
      "Set working hours and greeting / off-hours messages.",
      "Configure opt-in/out and webhook destination if you route events to your own systems.",
      "Invite agents and assign team roles.",
    ],
  },
  {
    title: "Templates, messaging, and campaigns",
    steps: [
      "Create WhatsApp templates and submit them to Meta for review.",
      "Wait for APPROVED (or fix REJECTED templates from webhook status updates).",
      "Send a test message to confirm the number is live.",
      "Use Live Chat for 24-hour session messages; use approved templates outside the window.",
      "Run broadcasts, Excel campaigns, and API campaigns from the dashboard.",
    ],
  },
  {
    title: "Operate, measure, and grow",
    steps: [
      "Monitor delivery, read, and failed receipts via webhooks.",
      "Review WABA analytics, quality rating, and messaging limits.",
      "Track plan quota and renew billing when needed.",
      "Reconnect via Embedded Signup if the business token is revoked or assets change.",
    ],
  },
];

const ServiceDetail = () => (
  <div className="sd-page">
    <header className="sd-topbar">
      <Link to="/" className="sd-brand">
        <img
          src={ASSETS.brandLogo}
          alt={ASSETS.brandName}
          className="sd-brand-logo"
        />
      </Link>
      <nav className="sd-topbar-links">
        <Link to="/">Home</Link>
        <Link to="/login">Sign in</Link>
        <Link to="/register" className="sd-topbar-cta">
          Get started
        </Link>
      </nav>
    </header>

    <main className="sd-main">
      <section className="sd-hero">
        <p className="sd-kicker">Onboarding</p>
        <h1>Service details</h1>
        <p>
          {ASSETS.brandName} is a SaaS platform acting as a Meta / WhatsApp Tech
          Provider. Businesses connect their own WhatsApp Business Account through
          Embedded Signup. The platform then sends and receives Cloud API messages
          on their behalf.
        </p>
      </section>

      <ol className="sd-phases">
        {PHASES.map((phase, index) => (
          <li key={phase.title} className="sd-phase">
            <span className="sd-phase-num">
              {String(index + 1).padStart(2, "0")}
            </span>
            <div className="sd-phase-body">
              <h2>{phase.title}</h2>
              <ol>
                {phase.steps.map((step) => (
                  <li key={step}>{step}</li>
                ))}
              </ol>
            </div>
          </li>
        ))}
      </ol>

      <aside className="sd-note">
        Embedded Signup must be launched from an allowed HTTPS domain, with a
        valid Meta App ID and Login for Business configuration ID. Token
        exchange and webhook subscription happen only on the server.
      </aside>

      <div className="sd-actions">
        <Link to="/" className="sd-btn-primary">
          Back to Home
        </Link>
        <p>
          Need an account? <Link to="/register">Register</Link>
          {" · "}
          <Link to="/login">Sign in</Link>
        </p>
      </div>
    </main>
  </div>
);

export default ServiceDetail;
